<template>
  <div class="page">
    <div class="margin-top">亲爱的用户，您好：</div>
    <div class="margin-top">在申请注销云圈账号前，请您确认以下事项：</div>

    <div class="margin-top">1、您的帐号已绑定手机号。</div>
    <div class="margin-top">
      2、您在最近两周内没有进行修改密码、换绑手机号等敏感信息的变更，且帐号没有被盗、被封等风险。
    </div>

    <div class="margin-top">
      此外，我们向您温馨提示，注销云圈帐号是不可恢复的操作，请自行备份您在云圈产品下的相关信息和数据。操作之前，请确认与帐号相关的所有服务均已妥善处理。注销帐号后，您将无法再次使用该帐号找回您的任何内容或信息，包括但不限于:
    </div>

    <div class="margin-top">1、注销生效后，该帐号将被永久注销，永远无法登录和注册云圈产品。</div>
    <div class="margin-top">
      2、该登录帐号在云圈产品中所有的个人资料和历史信息等数据，随帐号注销生效，一并清空。
    </div>
    <div class="margin-top">
      3、在帐号注销期间，如果您的帐号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，云圈有权自行终止您帐号的注销而无需另行得到您的同意。
    </div>
    <div class="margin-top">
     请注意:注销您的帐号并不代表该帐号注销前的所有帐号行为和相关责任得到豁免或减轻。
    </div>
    <div class="margin-top">
      该在线注销功能目前仅适用于已绑定手机号的用户。如您尚未绑定手机号，或者在注销过程中遇到任何问题或困难的，均可以通过APP内的客服电话联系客服人工处理。一般情况下，我们将核实您身份之日起15日内予以回复处理。请注意，您选择通过上述方式提交账号注销申请，将视为您已经阅读并同意本注销须知。
    </div>
    <div class="right">北京云圈科技有限公司</div>

    <div class="btn" v-on:click="agreeCancellation()">我已阅读注销须知</div>
  </div>
</template>
<script>
// 注销通知
import {callNative} from '../utils/native'

export default {
  name: 'CancellationNotice',
  data () {
    return {}
  },
  methods: {
    // 同意注销 js 回调
    agreeCancellation () {
      callNative('agreeCancellation')
    },

    isIos () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('iphone') > -1 || ua.indexOf('mac os') > -1
    },

  }

}
</script>

<style scoped>
.page {
  display: block;
  width: 6.9rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  /* padding-right: 0.3rem;
  padding-left: 0.3rem; */
}

div {
  color: #666;
  font-size: 0.34rem;
  text-align: left;
  width: 100%;
  line-height: 0.6rem;
  font-weight: normal;
  letter-spacing: 1px;
}

.margin-top {
  margin-top: 0.3rem;
}

.center {
  font-size: 0.36rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  text-align: center;
  color: #000;
}

.right {
  font-size: 0.36rem;
  color: #666;
  width: 100%;
  margin-top: 0.6rem;
  float: right;
  text-align: right;
  margin-bottom: 0.6rem;
  display: block;
}

.btn {
  display: block;
  margin-top: 1rem;
  clear: both;
  text-align: center;
  border-radius: 0.4rem;
  border: 1px solid #F84F3D;
  background-color: #F84F3D;
  height: 0.8rem;
  line-height: 0.8rem;
  color: white;
  font-size: 0.3rem;
  margin-bottom: 0.6rem;

}
</style>



// WEBPACK FOOTER //
// src/components/CancellationNotice.vue